import { render, staticRenderFns } from "./AgradecimientoSugerencia.vue?vue&type=template&id=4d5e3848"
import script from "./AgradecimientoSugerencia.vue?vue&type=script&lang=js"
export * from "./AgradecimientoSugerencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports